import React from 'react';

interface CurrencyModalProps {
    showModal: boolean;
    isLoading: boolean;
    onCurrencySelect: (currency: 'USD' | 'INR') => void;
    onClose: () => void;
}

const CurrencyModal: React.FC<CurrencyModalProps> = ({
    showModal,
    isLoading,
    onCurrencySelect,
    onClose,
}) => {
    if (!showModal) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-xl shadow-2xl p-8 max-w-xs w-full text-center">
                <h2 className="text-xl font-bold mb-4">Choose your payment currency</h2>
                <div className="flex flex-col gap-4">
                    <button
                        className="w-full py-2 px-4 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700 transition"
                        onClick={() => onCurrencySelect('INR')}
                        disabled={isLoading}
                    >
                        Pay in &#8377;(INR - Indian Rupee)
                    </button>
                    <button
                        className="w-full py-2 px-4 rounded-lg bg-secondary-500 text-white font-semibold hover:bg-secondary-600 transition"
                        onClick={() => onCurrencySelect('USD')}
                        disabled={isLoading}
                    >
                        Pay in $(USD - US Dollar)
                    </button>
                </div>
                <button
                    className="mt-6 text-text-description hover:text-text-heading text-sm underline"
                    onClick={onClose}
                    disabled={isLoading}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default CurrencyModal;
